import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { VsFormComponent } from '@app/widget/vs-form/vs-form.component';
import { VsGridComponent } from '@app/widget/vs-grid/vs-grid.component';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';


import { ApiConstants } from '@app/api-constants';
import { AppGlobalService } from '@app/app-global.service';
import { EllipsisService } from '@app/ellipsis.service';
import { ModalPopupService } from '@app/shared/services/modal-popup.service';
import { NotificationService } from '@app/shared/services/notification.service';
import { AppConstants } from '@custom/core/app-constants';
import { CustomService } from '@custom/services/custom.service';
import SecurityJson from '@app/security/changelog/changelog.security';
@Component({
  selector: 'app-dailysyncdashboard-detail',
  templateUrl: './dailysyncdashboard-detail.component.html',
  styleUrls: ['./dailysyncdashboard-detail.component.scss']
})
export class DailysyncdashboardDetailComponent implements OnInit {
  @ViewChild(VsFormComponent) child;
  public data = {};
  private dtTable: any;
  public formConfig: any;
  @ViewChild(VsGridComponent)
  private gridComp: any = VsGridComponent;
  public gridConfig: any = {};
  private isPrototyping: boolean;
  local: any = {};
  public pageName = 'DAILY_SYNC_DASHBOARD';
  filter: {};
  refreshGridMethod: () => void;

  dataChanged = (data) => {
    
  };
  public hasWorkflow = false;

  constructor(
    public appGlobal: AppGlobalService,
    public customService: CustomService,
    public element: ElementRef,
    public ellipsis: EllipsisService,
    public notification: NotificationService,
    public modalPopupService: ModalPopupService,
    public translate:TranslateService,
    private datePipe: DatePipe
  ) {
  }

  public onBeforeOnInit() {
    this.filter = {};
  }

  ngOnInit(): void {
    this.onBeforeOnInit();
    this.formConfig = this.getFormConfig(SecurityJson);
    this.gridConfig = this.loadGridConfig();
    this.isPrototyping = this.appGlobal.get('prototyping');
  }

  private getFormConfig(securityJson: any) {
    this.local.formConfig = {};

    this.local.formConfig.date = {
      security_code: 'date',
      label: 'Daily Sync Date',
      type: 'date',
      name: 'dailySyncdate123',
      placeholder: '',
      infoBubble: '',
      values: [],
      options: [],
      disabled: false,
      toolbar: true,
      displayonly: false,
      validations: {
      },
      formAttributes: {
        change: this.searchdata.bind(this),
      },
    };

    return {
      initCallback: this.changeLogFormInitComplete.bind(this),
      collapsible: false,
      submit: 'saveBasicDetails',
      class: 'no-margin form-elements-group',
      securityEvaluation: this.hasWorkflow,
      staticSecurityJson: securityJson,
      disabledForm: false,
      columns: 100,
      groups: [
        {
          groupHeaderClass: 'form-group-subheader hidden',
          groupContentClass: 'paddingZero',
          collapsible: 'false',
          columns: '100',
          label: '',
          disableRights: false,
          columnsWidth: 10,
          items: [
            {
              groupHeaderClass: 'form-group-subheader hidden',
              groupContentClass: 'paddingZero',
              collapsible: 'false',
              columns: '25',
              label: '',
              disableRights: false,
              columnsWidth: 10,
              items: [
                this.local.formConfig.date,
              ]
            },
      
          ]
        }
      ]
    };

  }

  private createRefresh(settings: any, json: any, dtTable: any) {
    this.refreshGridMethod = () => {
      this.gridComp.refreshGrid();
    };
  }

  public searchdata() {
    this.refreshGridMethod();
  }

  private loadGridConfig(): any {
    const self = this;
    let dailySyncMsg:any = '';
    const gridConfig: any = {
      autoWidth: false,
      ordering: false,
      customOrdering: false,
      columnDefs: [
        {
          "defaultContent": "",
          "targets": "_all"
        }
      ],
      columns: [
        {
          data: 'no_of_sync_Date', name: 'no_of_sync_Date', title: 'Sync Occurrence', type: 'number', width: '8%',render: (data: any, type: any, row: any) => {
            if (data != null) {
              const sync_occurence = data.split('_')[0];
              return sync_occurence;
            }
          }
        },
        {
          data: 'date', name: 'date', title: 'Date', type: 'string', width: '10%'
        },
        {
          data: 'users_count', name: 'users_count', title: 'Users Count', type: 'number', width: '13%'
        },
        {
          data: 'yes_count', name: 'yes_count', title: 'Number of Yes Flags', width: '13%', type: 'number'
        },
        {
          data: 'no_count', name: 'no_count', title: 'Number of No Flags', width: '13%', type: 'number'
        },
        {
          data: 'total_result_count', name: 'total_result_count', title: 'Total Results Count(Yes+No)', width: '15%', type: 'number',
        },
        { data: 'expected_result_count', name: 'expected_result_count', width: '20%', title: ' Expected Results Count(Users count * no of control group)', type: 'number' },
        {
          data: 'status', name: 'status', title: 'Status', type: 'string', width: '10%',conditionalColorField: 'status',
          conditionalColor: {
            'Match': 'dailysync-dailysync-matched',
            'Mismatch': 'dailysync-dailysync-mismatched',
            'In Progress': 'status-status-in-progress',
            'Matched': 'dailysync-dailysync-matched',
            'Mismatched': 'dailysync-dailysync-mismatched',
            'Error':'dailysync-dailysync-error'
          }
        }
      ],
      searchMandatory: true,
      emptyTableMsg: "Daily Sync is not yet started processing for the current date",
      infoEmpty: "Since,we have issue in connecting to SAP for site and company sync,the daily sync has not processed for the selected date",
      disableSelection: true,
      onRowSelect: (selectedRows: any, id: any) => {
      },
      onRowDeselect: (selectedRows: any) => {
      },
      onInitComplete: (dtTable: any, settings: any, json: any) => {
        self.dtTable = dtTable;
        self.createRefresh(settings, json, dtTable);
        //setTimeout(() => {
        self.setGridHeight(settings, json, dtTable);
        //}, 1000);
      },
      fnServerParams: (searchObj) => {
        return this.extendFnServerParams(searchObj);
      },
      onBeforeGridServiceRequest: (params: any, isFromSort: boolean, isFromRefresh: boolean) => {
      },
      onAfterGridServiceResponse: (params: any, isFromSort: boolean, isFromRefresh: boolean, data: any) => {
      },
      onRowCreate: (row: any, data: any, dataIndex: any) => {
      },
      onRowClick: (event: any, id: any) => {

      },
      drawCallback: (settings: any) => {
      },
      headerCallback: (thead: any, data: any, start: any, end: any, display: any) => {
      },
      preDrawCallback: (settings: any) => {
      },
      rowCallback: (row: any, data: any, index: any) => {
      },
      maxRowsAllowedForSelection: AppConstants.maxRowsAllowedToSelect,
      rowMenuOptions: [
      ],
      beforeRowMenuShow: (option: any, data: any, row: any) => {
      },
      onRowMenuClick: (option: any, row: any, data: any) => {
      },
      onMobileRowDisplay: (row: Node, data: any[] | object, index: number) => {
        return row;
      },
      complexHeader: [
      ]
    };


    gridConfig.scrollY = self.getGridHeight();

    if (this.isPrototyping) {
      gridConfig.method = 'get';
      gridConfig.ajaxUrl = '/assets/data/Results.json';

    } else {
      gridConfig.ajaxMethod = 'POST';
      gridConfig.ajaxUrl = '/' + AppConstants.apihost + '/' + ApiConstants.getDailySyncDashboard.url;
    }

    return gridConfig;
  }

  private getGridHeight() {
    const currentEl = this.element.nativeElement;
    const gridEl = currentEl.querySelector('app-vs-grid');
    const gridElOffsetTop = gridEl.querySelector('div').offsetTop + (AppConstants.isMobile ? 40 : 90);
    let gridHeight = window.innerHeight - gridElOffsetTop;
    return gridHeight;
  }

  private setGridHeight(settings: any, json: any, dtTable: any) {
    const gridHeight = this.getGridHeight();
    $(settings.nScrollBody).css({ height: gridHeight + 'px', 'max-height': gridHeight + 'px' });
  }

  public handleCustomEvents(e: Event, form?: any) { }

  public changeLogFormInitComplete(form: any) {
  }

  public extendFnServerParams(searchObj) {
    if (Object.keys(this.filter).length > 0) {
      $.extend(searchObj, this.filter);
    }

    if (this.child != null && this.child.form != null && this.child.form.value) {

      if (!this.child.form.value.dailySyncdate123) {
        this.child.form.value.dailySyncdate123 = '';
      }

      this.child.form.value.dailySyncdate123 = this.datePipe.transform(this.child.form.value.dailySyncdate123,'dd-MMM-yyyy');
      searchObj =
      {
        'date': this.child.form.value.dailySyncdate123,
        
      }

      
    }
    //TODO -  pass filter data in search
    return searchObj;
  }

 

  private zeroPadding = (num, places) => String(num).padStart(places, '0');

  public getFormattedDate(data: any) {
    if(!data) {
      return data;
    }

    const date = new Date(data);

    if (date.toLocaleDateString() != 'Invalid Date') {
      return date.getFullYear() + '-' + this.zeroPadding(date.getMonth() + 1, 2) + '-' + this.zeroPadding(date.getDate(),2);
    }

    if(date.toLocaleDateString() != 'Invalid Date') {
      return date.toISOString().split('T')[0]
    }
    
    return null;
  }

}
